import { useEffect, useState, useMemo, useRef } from "react";

function useSlideIn({
  delay = 250,
  duration = 250,
  x = 0,
  y = 0,
  inX = 0,
  inY = 0,
  show,
  opacity = 1,
}) {
  const [transform, setTransform] = useState(
    `translate(${x || 0}px, ${y || 0}px)`
  );
  const [auxOpactiy, setAuxOpacity] = useState(0);
  const transition = useMemo(() => `all ${duration}ms ease`, [duration]);
  const pointerEvents = useMemo(() => (show ? "auto" : "none"), [show]);

  const timerRef = useRef();

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (show) {
      timerRef.current = setTimeout(() => {
        setTransform(`translate(${inX}px, ${inY}px)`);
        setAuxOpacity(opacity);
      }, delay);
    } else {
      setTransform(`translate(${x || 0}px, ${y || 0}px)`);
      setAuxOpacity(0);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [x, y, inX, inY, delay, show, opacity]);

  return { transform, opacity: auxOpactiy, transition, pointerEvents };
}

export default useSlideIn;
